import React, { useMemo } from 'react';
import c from 'classnames';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import { constructVariableRatiosImageSourcesObject } from '../../../../../helpers/constructImageSources';
import TaxonomyThemeCardChild from '../../../../../implementations/Taxonomy/Theme/Card/Child';
import TaxonomyThemeCardParent from '../../../../../implementations/Taxonomy/Theme/Card/Parent';
import type { SearchAllContentThemeHit } from '../../../../SearchAllContent/types';
import searchTaxonomyIconMapper from '../../../searchIconMapper';

const MetaSearchThemeHit: React.FC<{ hit: SearchAllContentThemeHit }> = ({ hit }) => {
  const icon = useMemo(() => searchTaxonomyIconMapper(hit), [hit]);

  // If the taxonomy has a parent, it must be a child.
  if (hit.taxonomy_parent_tid) {
    return (
      <TaxonomyThemeCardChild
        className="MetaSearchThemeHit"
        url={hit.url[0]}
        title={hit.taxonomy_name[0]}
        image={(
          <Image
            src={constructVariableRatiosImageSourcesObject(
              hit,
              ['1_1', '1_1', '1_1', '1_1', '1_1'],
              ['sm', 'sm', 'sm', 'sm', 'sm'],
            )}
            alt={hit.taxonomy_image_alt?.[0]}
            lazyload={false}
          />
        )}
      />
    );
  }

  // If the taxonomy has no parent, itself must be a parent.
  return (
    <TaxonomyThemeCardParent
      className={c('MetaSearchThemeHit', hit.taxonomy_label_icon_classes?.[0] ?? 'u-background--secondary--400')}
      url={hit.url[0]}
      title={hit.taxonomy_name[0]}
      icon={icon.name}
      iconFlair={icon.flair}
    />
  );
};

export default MetaSearchThemeHit;
